import retrieveNotifications from "./retrieveNotifications";
import markAsRead from "./markAsRead";

export default {
  retrieveNotifications,
  markAsRead,
};
